import { useProfileContext, Profile, UpdateProfileInput, UserStats } from "@lyder-talk/core";

// Re-export types for backwards compatibility
export type { Profile, UpdateProfileInput, UserStats };

/**
 * useProfile hook - provides profile state and methods
 * This is a wrapper around ProfileContext for backwards compatibility
 */
export const useProfile = () => {
  const profileContext = useProfileContext();

  return {
    profile: profileContext.profile,
    isLoading: profileContext.isLoading,
    error: profileContext.error,
    updateProfile: profileContext.updateProfile,
    isUpdating: profileContext.isUpdating,
    // New API
    refreshProfile: profileContext.refreshProfile,
  };
};

/**
 * Aggregate account stats, re-exported from `@lyder-talk/core`.
 *
 * The previous version here wrapped the context and fired a `useEffect` that
 * called `refreshStats()` on mount, which was both a render loop waiting to
 * happen and a way to force the fetch from a component that only renders inside
 * a closed dialog. The query now owns its own `enabled` flag — pass
 * `{ enabled: open }` from dialog content.
 */
export { useUserStats } from "@lyder-talk/core";
export type { UseUserStatsOptions } from "@lyder-talk/core";
